/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/prop-types */
import { forwardRef, useRef } from 'react';
// import InputLabel from '@mui/material/InputLabel';
// import FormHelperText from '@mui/material/FormHelperText';
// import FormControl from '@mui/material/FormControl';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'reac... Remove this comment to see the full error message
import Select from 'react-select-virtualized';

import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import CancelIcon from '@mui/icons-material/Cancel';

import { useTheme, Typography, TextField, Paper, Chip, MenuItem, emphasize } from '@mui/material';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      flexGrow: 1,
      height: 250,
      minWidth: 290,
    },
    input: {
      display: 'flex',
      height: 20,
      backgroundColor: 'transparent',
    },
    valueContainer: {
      display: 'flex',
      flexWrap: 'nowrap',
      flex: 1,
      alignItems: 'center',
      overflow: 'hidden',
      height: 20,
    },
    chip: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      margin: theme.spacing(0.5, 0.25),
    },
    chipFocused: {
      backgroundColor: emphasize(
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
        0.08
      ),
    },
    noOptionsMessage: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      padding: theme.spacing(1, 2),
    },
    singleValue: {
      fontSize: 16,
      whiteSpace: 'nowrap',
    },
    placeholder: {
      position: 'absolute',
      bottom: 16,
      fontSize: 16,
      opacity: 0,
    },
    '@global': {
      '.focused': {
        '& $placeholder': {
          opacity: 1,
        },
      },
    },
    paper: {
      overflow: 'hidden',
      position: 'absolute',
      zIndex: 9,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      marginTop: theme.spacing(1),
      left: 0,
      right: 0,
      '& .flat-virtualized-item': {
        fontSize: 16,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      '& .fast-option-selected': {
        color: '#fff',
      },
    },
    divider: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      height: theme.spacing(2),
    },
  }),
  { name: 'BringerReactSelect' }
);

function NoOptionsMessage({ children, selectProps, innerProps }: any) {
  return (
    <Typography
      color="textSecondary"
      className={selectProps.classes.noOptionsMessage}
      {...innerProps}
    >
      {children}
    </Typography>
  );
}

NoOptionsMessage.propTypes = {
  /**
   * The children to be rendered.
   */
  children: PropTypes.node,
  /**
   * Props to be passed on to the wrapper.
   */
  innerProps: PropTypes.object.isRequired,
  selectProps: PropTypes.object.isRequired,
};

// @ts-expect-error ts-migrate(2339) FIXME: Property 'inputRef' does not exist on type '{ chil... Remove this comment to see the full error message
const inputComponent = forwardRef(({ inputRef, ...props }, ref) => <div ref={ref} {...props} />);

inputComponent.propTypes = {
  // @ts-expect-error ts-migrate(2322) FIXME: Type '{ inputRef: PropTypes.Requireable<((...args:... Remove this comment to see the full error message
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({
      current: PropTypes.any.isRequired,
    }),
  ]),
};

function Control(props: any) {
  const {
    children,
    innerProps,
    innerRef,
    selectProps: { InputInputProps, classes, TextFieldProps },
  } = props;

  const { defaultOptions, ...restTextFieldProps } = TextFieldProps;

  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: classes.input,
          ref: innerRef,
          children,
          ...innerProps,
        },
        ...InputInputProps,
      }}
      {...restTextFieldProps}
    />
  );
}

Control.propTypes = {
  /**
   * Children to render.
   */
  children: PropTypes.node,
  /**
   * The mouse down event and the innerRef to pass down to the controller element.
   */
  innerProps: PropTypes.shape({
    onMouseDown: PropTypes.func.isRequired,
  }).isRequired,
  innerRef: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.func,
    PropTypes.shape({
      current: PropTypes.any.isRequired,
    }),
  ]).isRequired,
  selectProps: PropTypes.object.isRequired,
};

function Option({ children, isFocused, isSelected, innerProps, key }: any) {
  console.log(innerProps, 'innerProps');
  console.log(key, 'key');
  return (
    <MenuItem
      // ref={innerRef}
      selected={isFocused}
      component="div"
      style={{
        fontWeight: isSelected ? 500 : 400,
      }}
      {...innerProps}
    >
      {children}
    </MenuItem>
  );
}

Option.propTypes = {
  /**
   * The children to be rendered.
   */
  children: PropTypes.node,
  /**
   * props passed to the wrapping element for the group.
   */
  innerProps: PropTypes.shape({
    id: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    onMouseMove: PropTypes.func.isRequired,
    onMouseOver: PropTypes.func.isRequired,
    tabIndex: PropTypes.number.isRequired,
  }).isRequired,
  /**
   * Whether the option is focused.
   */
  isFocused: PropTypes.bool.isRequired,
  /**
   * Whether the option is selected.
   */
  isSelected: PropTypes.bool.isRequired,
};

function Placeholder(props: any) {
  const { selectProps, innerProps = {}, children } = props;
  return (
    <Typography color="textSecondary" className={selectProps.classes.placeholder} {...innerProps}>
      {children}
    </Typography>
  );
}

Placeholder.propTypes = {
  /**
   * The children to be rendered.
   */
  children: PropTypes.node,
  /**
   * props passed to the wrapping element for the group.
   */
  innerProps: PropTypes.object,
  selectProps: PropTypes.object.isRequired,
};

function SingleValue({ children, selectProps, innerProps }: any) {
  return (
    <Typography className={selectProps.classes.singleValue} {...innerProps}>
      {children}
    </Typography>
  );
}

SingleValue.propTypes = {
  /**
   * The children to be rendered.
   */
  children: PropTypes.node,
  /**
   * Props passed to the wrapping element for the group.
   */
  innerProps: PropTypes.any.isRequired,
  selectProps: PropTypes.object.isRequired,
};

function ValueContainer({ selectProps, children }: any) {
  return <div className={selectProps.classes.valueContainer}>{children}</div>;
}

ValueContainer.propTypes = {
  /**
   * The children to be rendered.
   */
  children: PropTypes.node,
  selectProps: PropTypes.object.isRequired,
};

function MultiValue({ children, selectProps, isFocused, removeProps }: any) {
  return (
    <Chip
      tabIndex={-1}
      label={children}
      className={clsx(selectProps.classes.chip, {
        [selectProps.classes.chipFocused]: isFocused,
      })}
      onDelete={removeProps.onClick}
      deleteIcon={<CancelIcon {...removeProps} />}
    />
  );
}

MultiValue.propTypes = {
  children: PropTypes.node,
  isFocused: PropTypes.bool.isRequired,
  removeProps: PropTypes.shape({
    onClick: PropTypes.func.isRequired,
    onMouseDown: PropTypes.func.isRequired,
    onTouchEnd: PropTypes.func.isRequired,
  }).isRequired,
  selectProps: PropTypes.object.isRequired,
};

function Menu({ children, selectProps, innerProps }: any) {
  return (
    <Paper className={selectProps.classes.paper} {...innerProps}>
      {children}
    </Paper>
  );
}

Menu.propTypes = {
  /**
   * The children to be rendered.
   */
  children: PropTypes.element.isRequired,
  /**
   * Props to be passed to the menu wrapper.
   */
  innerProps: PropTypes.object.isRequired,
  selectProps: PropTypes.object.isRequired,
};

const components = {
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
};

export default function ReactSelect({
  input: { name, onChange, onBlur, onFocus, value },
  meta,
  label,
  options,
  styles,
  variant,
  required,
  helperText,
  inputInput = {},
  classes,
  menuPortalTarget,
  onChange: onChangeProp,
  ...rest
}: any) {
  const ref = useRef();
  const select = useRef();
  const classesOwn = useStyles();
  const theme = useTheme();
  const selectStyles = {
    input: (base: any) => ({
      ...base,
      color: theme.palette.text.primary,

      '& input': {
        font: 'inherit',
      },
    }),
  };

  if (classes && !ref.current) {
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'true' is not assignable to type 'undefined'.
    ref.current = true;
    Object.keys(classes).forEach((key) => {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      if (!classesOwn[key]) {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        classesOwn[key] = classes[key];
      } else {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        classesOwn[key] += ` ${classes[key]}`;
      }
    });
  }

  const handleOnChange = ({ ...attrs }) => {
    onChange(attrs);
    if (onChangeProp) onChangeProp(attrs);
  };

  return (
    <Select
      ref={select}
      menuPortalTarget={menuPortalTarget}
      inputId={name}
      classes={classesOwn}
      onChange={handleOnChange}
      onBlur={onBlur}
      onFocus={onFocus}
      options={options}
      styles={{ ...selectStyles, ...styles }}
      value={value}
      components={components}
      InputInputProps={inputInput}
      TextFieldProps={{
        // onKeyDown: e => {
        //   console.log(select);
        //   console.log(select.current.focus(2));
        //   console.log(e, 'here');
        // },
        label,
        required,
        variant,
        InputLabelProps: {
          htmlFor: name,
          shrink: !!value || meta.active,
        },
        helperText: meta.touched ? meta.error : helperText,
        error: meta.error && meta.touched,
        ...rest,
      }}
    />
  );
}
